import { Helmet } from 'react-helmet-async';
import { useState, useEffect, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

// @mui
import { Container, Card } from '@mui/material';
// components
import { useSettingsContext } from '../../../components/settings';
import AppCache from '../../../services/appcache';
import MastersService from '../../../services/masters.services';
import DetailsAndAcknowledgement from '../../../sections/setdealer/dealer/detailsandacknowledgement';
import DealerHeader from '../../../sections/setdealer/dealerheader';
// --------------------------------------------------------------------------------------------------------------

export default function AcknowledgementPage() {

    const navigate = useNavigate();
    const { themeStretch } = useSettingsContext();
    const { uploadName } = useParams();
    const [enableReuploadData, setEnableReuploadData] = useState([]);
    const currentDate = useMemo(() => new Date(), []);
    const previousMonthDate = new Date(currentDate);
    previousMonthDate.setMonth(previousMonthDate.getMonth() - 1);
    const [selectedDate, setSelectedDate] = useState(null);
    const [lastDate, setLastDate] = useState(null);
    const currentMonth = currentDate.getMonth();
    const currentYear = currentDate.getFullYear();
    const [cutOffDay, setCutOffDay] = useState(null);
    const enableDataMode = AppCache.GetEnableDataMode();
    const [openModalForError, setOpenModalForError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [loading, setLoading] = useState(false);
    const [columnData, setColumnData] = useState([]);
    const [rowData, setRowData] = useState([]);
    const [importHistoryLoading, setImportHistoryLoading] = useState(false);
    const [noOfRecords, setNoOfRecords] = useState(100);

    useEffect(() => {

        setColumnData([]);
        setRowData([]);

        setColumnData(MastersService.GetColumns('helptopics'));
        setRowData(MastersService.GetRowData('helptopics'));

    }, []);

    const closeErrorPopup = () => {
        setOpenModalForError(false);
    }

    return (
        <>
            <Helmet>
                <title> Details & Acknowledgement | JJ Core </title>
            </Helmet>

            <Container maxWidth={themeStretch ? false : 'xl'}>

                <DealerHeader headerName="Sets" breadcrumbsName="Acknowlwdgement" />

                <DetailsAndAcknowledgement/>
            </Container>
        </>
    );
}
